<template>
  <div>
    <!--v-bind= "nome do objeto"-->
    <!--Barra de pesquisa-->
    <default-form-validation-provider
      label="Unidade Gestora"
      v-slot="defaultState"
    >
      <multiselect
        v-model="Ugs.Nome"
        open-direction="bottom"
        :state="defaultState.state"
        placeholder="Selecione uma UG"
        track-by="Codigo"
        :options="listaUGs"
        label="Nome"
        :allow-empty="true"
        v-bind="multiselectprops"
        @select="adicionarUG"
      >
        <template slot="noOptions">
          <small><i>Erro ao obter dados.</i></small>
        </template>
        <template slot="noResult">
          <i>Sem resultados.</i>
        </template>
      </multiselect>
    </default-form-validation-provider>
    <div>
      <b-table
        striped
        hover
        stacked="md"
        show-empty
        :items="this.ugSelecionadasComp"
        :fields="computedFields"
      >
        <template #empty>
          <span>Nenhuma UG foi selecionada.</span>
        </template>
        <template slot="cell(actions)" slot-scope="UgData">
          <b-button size="sm" @click="excluirItemUG(UgData.item)">
            <font-awesome-icon icon="trash" />
          </b-button>
        </template>

        <template slot="cell(Nome)" slot-scope="UgData">
          <div>
            <b>{{ UgData.item.Nome }}</b>
          </div>
          <div v-if="UgData.item.gestorUG">
            <small
              ><i>{{ UgData.item.gestorUG.nome }}</i></small
            >
          </div>
          <div v-else>
            <small><i>Sem gestor(a)</i></small>
          </div>
        </template>
        <template #head(actions)>
          <div>
            <!--Botão para remover todas as UGs-->
            <b-button size="sm" @click="excluirTodosItensUG">
              <font-awesome-icon icon="ban" />
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>
<script lang="ts">
import { mixins } from "vue-class-component";
import { UtilsTS } from "@/utilsts";
import { Component, Vue, Watch } from "vue-property-decorator";
import { UnidadeGestoraResumida } from "@/types/ug/unidade-gestora-resumida";
import ugService from "@/services/administracao/ugService";
import { store } from "@/store";
import Multiselect from "vue-multiselect";
import { MultiSelectDefaultProps } from "@/types/form-default-props";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import { PropType } from "vue";

const CompProps = Vue.extend({
  name: "SeletorDeUGs",
  components: { Multiselect, DefaultFormValidationProvider },
  props: {
    ugsSelecionadas: {
      type: Array as PropType<UnidadeGestoraResumida[]>,
      required: false,
    },
  },
});

@Component
export default class SeletorDeUGs extends mixins(UtilsTS, CompProps) {
  multiselectprops = MultiSelectDefaultProps;
  Ugs: UnidadeGestoraResumida = new UnidadeGestoraResumida();
  listaUGs: UnidadeGestoraResumida[] = [];
  listaUgsSelecionadas: UnidadeGestoraResumida[] = [];
  ugSelecionadasComp: UnidadeGestoraResumida[] = [];

  async mounted() {
    try {
      store.blockScreen = true;
      this.carregarUGs();
    } catch (e) {
      console.error(e);
    } finally {
      store.blockScreen = false;
    }
    //this.listaPerfisUG = this.perfisUsuarioUG
    //console.log(this.listaPerfisUG)
  }

  @Watch("ugsSelecionadas", { deep: true })
  onUGChange() {
    if (
      this.ugsSelecionadas.length === 0 &&
      this.listaUgsSelecionadas.length > 0
    ) {
      this.excluirTodosItensUG();
    }
  }

  get computedFields() {
    const fields = [{ key: "Nome", label: "UGs selecionadas" }];
    if (this.listaUgsSelecionadas.length > 0) {
      fields.push({ key: "actions", label: "" });
    }
    return fields;
  }

  //Buscar Perfis
  async carregarUGs() {
    try {
      this.listaUGs = await ugService.listarUGs(500, 1);
      //console.log(this.listaUGs)
    } catch (e: any) {
      this.tratarError(e);
      //console.log('caiu no catch')
    }
  }

  adicionarUG(UG: UnidadeGestoraResumida) {
    if (!this.listaUgsSelecionadas.includes(UG)) {
      this.chamarUGCompleta(UG);
      this.listaUgsSelecionadas.push(UG);
      this.$emit("AtualizarListaAdd", this.listaUgsSelecionadas);
      //console.log(this.ugsSelecionadas)
      //console.log(this.ugSelecionadasComp)
    }
    //console.log(this.listaUgsSelecionadas)
  }

  async chamarUGCompleta(ug: UnidadeGestoraResumida) {
    try {
      store.blockScreen = true;
      const response = await ugService.obterUGgestor(String(ug.Codigo));
      this.ugSelecionadasComp.push(response);
    } catch (e: any) {
      this.tratarError(e);
      //console.log('Caiu no catch')
    } finally {
      store.blockScreen = false;
      //console.log(this.ugSelecionadasComp)
    }
  }

  //Exclui item individual da tabela de UGs selecionadas
  excluirItemUG(item: UnidadeGestoraResumida) {
    this.listaUgsSelecionadas = this.listaUgsSelecionadas.filter(
      (UG) => UG.idCRP !== item.idCRP
    );
    this.ugSelecionadasComp = this.ugSelecionadasComp.filter(
      (UG) => UG.idCRP !== item.idCRP
    );
    //console.log(this.ugSelecionadasComp)
    //Emit para atualizar a lista do componente pai
    this.$emit("AtualizarListaDel", this.listaUgsSelecionadas);
  }

  excluirTodosItensUG() {
    this.ugSelecionadasComp = [];
    this.listaUgsSelecionadas = [];
    //console.log(this.ugSelecionadasComp)
    this.$emit("AtualizarListaDel", this.listaUgsSelecionadas);
  }
}
</script>

<style scoped>
.custom-table th.actions,
.custom-table td.actions {
  width: 35%; /* Ajuste o valor conforme necessário */
}
</style>
